import { Either, pipe, Task } from "fp";

import { creator, effects, reducer, type } from "~/Action/Definition";
import * as Data from "~/Data";
import * as Messaging from "~/Messaging";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Driver Messages summary requested" as const),
    reducer(
      ({ state }) =>
        (state.messages.summary.store = Data.Store.requested(
          state.messages.summary.store
        ))
    ),
    effects(({ dispatch, state: { context, companies } }) => {
      return pipe(
        context,
        Messaging.Summary.Request.Get.request(companies.current.company),
        Task.map((result) => dispatch(Received.create(result)))
      )();
    })
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Driver Messages Summary received" as const),
    creator(
      (
        result?: Either<Error, Data.Cache.Cache<Messaging.Summary.Summary>>
      ) => ({ result })
    ),
    reducer(
      ({ state, action: { result } }) =>
        (state.messages.summary.store = pipe(
          state.messages.summary.store,
          Data.Store.received(result)
        ))
    )
  );
}
